<script setup>
import { ref, onMounted, computed } from "vue";
import { useTheme } from "vuetify";
import { storeToRefs } from "pinia";
import { patch24Store } from "@/stores/patch24";
const patch24 = patch24Store();
const { selectedLicense } = storeToRefs(patch24);
import { appBarStore } from "@/stores/appBar";
import { apiQuery } from "@/api/j24api";
import AlertsList from "@/components/AlertsList.vue";
import { permissionsStore } from "@/stores/permissions";
const permissions = permissionsStore();

const appBar = appBarStore();

const theme = useTheme();

const licenseConfig =
  '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd"><plist version="1"><dict><key>PayloadUUID</key><string>8F0EE0E1-7115-4C3D-89F2-6F1CA929ABBA</string><key>PayloadType</key><string>Configuration</string><key>PayloadOrganization</key><string>Testing Company</string><key>PayloadIdentifier</key><string>8F0EE0E1-7115-4C3D-89F2-6F1CA929ABBA</string><key>PayloadDisplayName</key><string>Patch24 License</string><key>PayloadDescription</key><string/><key>PayloadVersion</key><integer>1</integer><key>PayloadEnabled</key><true/><key>PayloadRemovalDisallowed</key><true/><key>PayloadScope</key><string>System</string><key>PayloadContent</key><array><dict><key>PayloadDisplayName</key><string>Custom Settings</string><key>PayloadIdentifier</key><string>CC2D80A6-2AB4-4637-A571-96E5B523E4CC</string><key>PayloadOrganization</key><string>JAMF Software</string><key>PayloadType</key><string>com.apple.ManagedClient.preferences</string><key>PayloadUUID</key><string>CC2D80A6-2AB4-4637-A571-96E5B523E4CC</string><key>PayloadVersion</key><integer>1</integer><key>PayloadContent</key><dict><key>com.jigsaw24.Patch24</key><dict><key>Forced</key><array><dict><key>mcx_preference_settings</key><dict><key>key</key><string>**KEY**</string><key>license</key><string>**LICENSE**</string></dict></dict></array></dict></dict></dict></array></dict></plist>';

theme.global.name.value = "jigsawNew";

let apiKey = ref("KEY NOT SET");
let licenseKey = ref("KEY NOT SET");
const showCopiedMessage = ref(false);
const loading = ref(false);
const alerts = ref([]);
const grantAccessDialog = ref(false);
const selectedDuration = ref(24);
const grantSupportAccessDisabled = ref(false);

function hasPermission(permissionKey) {
  console.log(
    "Checking permission for key:",
    permissionKey,
    permissions.$state
  );
  let result = permissions.$state && permissions.$state[permissionKey];
  console.log("Permission result:", result);
  return result;
}

function downloadLicenseConfig() {
  if (!selectedLicense.value?._id) {
    alerts.value.push({
      type: "error",
      message: "No license selected",
      closable: true,
    });
    return;
  }

  // Generate random UUID for PayloadIdentifier
  function generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  var mobileconfig = licenseConfig.replace(
    "**KEY**",
    selectedLicense.value.license.apiKey || "KEY NOT SET"
  );
  mobileconfig = mobileconfig.replace(
    "**LICENSE**",
    selectedLicense.value.license.key || "LICENSE NOT SET"
  );

  // Replace PayloadIdentifier with random UUID
  const newUUID = generateUUID().toUpperCase();
  mobileconfig = mobileconfig.replace(
    /8F0EE0E1-7115-4C3D-89F2-6F1CA929ABBA/g,
    newUUID
  );

  let element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(mobileconfig)
  );
  element.setAttribute("download", "Patch24 License.mobileconfig");

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();
  document.body.removeChild(element);
}

function copyToClipboard(value) {
  navigator.clipboard.writeText(value).then(
    () => {
      showCopiedMessage.value = true;
      setTimeout(() => {
        showCopiedMessage.value = false;
      }, 2000);
    },
    () => {
      // Failure
    }
  );
}

onMounted(() => {
  if (appBar.selected && !selectedLicense.value?._id) {
    getLicense(appBar.selected);
  } else if (selectedLicense.value?._id) {
    apiKey.value = selectedLicense.value.license?.apiKey || "Key Not Set";
    licenseKey.value = selectedLicense.value.license?.key || "Key Not Set";
  }
});

appBar.$subscribe(() => {
  console.log("Appbar changed", appBar.$state);
  if (appBar.selected) {
    getLicense(appBar.selected);
    //getDevices();
  }
});

async function getLicense(id) {
  return;
  // loading.value = true;
  // try {
  //   var result = await apiQuery("ELA", "patching/patchingManagement", {
  //     action: "getPatchingLicense",
  //     id: id,
  //   });
  //   if (result.length) {
  //     selectedLicense.value = result[0];
  //     apiKey.value = selectedLicense.value.license.apiKey || "Key Not Set";
  //     licenseKey.value = selectedLicense.value.license.key || "Key Not Set";
  //     loading.value = false;
  //   } else {
  //     alerts.value.push({
  //       type: "error",
  //       message: "Error getting license",
  //       closable: true,
  //     });
  //   }
  // } catch (error) {
  //   alerts.value.push({
  //     type: "error",
  //     message: "Error getting license",
  //     closable: true,
  //   });
  // }
  // loading.value = false;
}

function openGrantAccessDialog() {
  grantAccessDialog.value = true;
}

const downloadingAgent = ref(false);
async function getAgentDownloadLink() {
  downloadingAgent.value = true;
  try {
    var result = await apiQuery("ELA", "patching/patchingManagement", {
      action: "getDownloadAgentLink",
      id: selectedLicense.value._id,
    });
    if (result.url) {
      window.open(result.url, "_self");
    } else {
      alerts.value.push({
        type: "error",
        message: "Error getting download link",
        closable: true,
      });
    }
  } catch (error) {
    alerts.value.push({
      type: "error",
      message: "Error getting download link",
      closable: true,
    });
  }
  downloadingAgent.value = false;
}

async function grantSupportAccess() {
  grantAccessDialog.value = false;
  loading.value = true;
  try {
    var result = await apiQuery("J24Auth", "grantSupportAccess", {
      customerId: selectedLicense.value.customerId,
      durationHours: selectedDuration.value,
      type: "PatchingV2",
    });
    if (result.message == "Patch 24 support access granted.") {
      alerts.value.push({
        type: "success",
        message: `Support access granted successfully`,
        closable: true,
      });
      loading.value = false;
      grantSupportAccessDisabled.value = true;
    } else {
      alerts.value.push({
        type: "error",
        message: "Error granting support access",
        closable: true,
      });
    }
  } catch (error) {
    alerts.value.push({
      type: "error",
      message: "Error granting support access",
      closable: true,
    });
  }
  loading.value = false;
}
</script>

<template>
  <AlertsList v-model="alerts" />
  <template v-if="!appBar.selected">
    <v-row>
      <v-col>
        <h1 v-if="appBar.items.length > 1">Select Patching License Above</h1>
        <h1 v-else>Loading please wait...</h1>
      </v-col>
    </v-row>
  </template>
  <template v-if="selectedLicense && selectedLicense._id">
    <v-row>
      <v-col cols="auto">
        <h1>Support</h1>
      </v-col>
    </v-row>
    <v-row class="d-flex align-stretch">
      <v-col cols="6">
        <v-card height="100%" class="d-flex flex-column" rounded="lg">
          <v-card-text class="d-flex flex-column flex-grow-1">
            <v-row class="flex-grow-1">
              <v-col cols="auto">
                <v-sheet rounded color="grey-lighten-2" alignself="center">
                  <v-icon class="ma-3" size="x-large"
                    >mdi-file-document-outline</v-icon
                  >
                </v-sheet>
              </v-col>
              <v-col class="d-flex flex-column">
                <div class="d-flex flex-column h-100">
                  <h3>Patch24 Documentation</h3>
                  <p class="mt-3 flex-grow-1">
                    Access documentation for Patch24 including setup guides,
                    troubleshooting tips, and best practices to help you get the
                    most out of the platform.
                  </p>
                  <a href="https://docs.jigsaw24.com/Patch24" target="_blank">
                    <v-btn
                      color="primary"
                      max-width="160"
                      class="mt-3 align-self-start"
                    >
                      Documentation
                    </v-btn>
                  </a>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card height="100%" class="d-flex flex-column" rounded="lg">
          <v-card-text class="d-flex flex-column flex-grow-1">
            <v-row class="flex-grow-1">
              <v-col cols="auto">
                <v-sheet rounded color="grey-lighten-2" alignself="center">
                  <v-icon class="ma-3" size="x-large"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-sheet>
              </v-col>
              <v-col class="d-flex flex-column">
                <div class="d-flex flex-column h-100">
                  <h3>Contact Support</h3>
                  <p class="mt-3 flex-grow-1">
                    If you need assistance with Patch24, our support team is
                    here to help. Please reach out with any questions or issues
                    you may have.
                  </p>

                  <v-row>
                    <v-col cols="auto">
                      <a
                        href="https://j24prod.service-now.com/csm?id=csm_login"
                        target="_blank"
                      >
                        <v-btn
                          color="primary"
                          max-width="160"
                          class="mt-3 align-self-start"
                          >Support</v-btn
                        ></a
                      >
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        v-if="hasPermission('PatchingV2-SupportAccess')"
                        @click="openGrantAccessDialog"
                        variant="elevated"
                        class="mt-3"
                        color="primary"
                        :disabled="grantSupportAccessDisabled"
                      >
                        Grant Support Access
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto">
        <h2>License</h2>
      </v-col>
    </v-row>
    <v-row class="d-flex align-stretch">
      <v-col cols="6">
        <v-card height="100%" class="d-flex flex-column" rounded="lg">
          <v-card-text class="d-flex flex-column flex-grow-1">
            <v-row class="flex-grow-1">
              <v-col cols="auto">
                <v-sheet rounded color="grey-lighten-2" alignself="center">
                  <v-icon class="ma-3" size="x-large">mdi-monitor</v-icon>
                </v-sheet>
              </v-col>
              <v-col class="d-flex flex-column">
                <div class="d-flex flex-column h-100">
                  <h3>License Information</h3>
                  <p class="mt-3">Expiry Date: {{ selectedLicense.enddate }}</p>
                  <p class="mt-3">
                    Total Licenses: {{ selectedLicense.count }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card height="100%" class="d-flex flex-column" rounded="lg">
          <v-card-text class="d-flex flex-column flex-grow-1">
            <v-row class="flex-grow-1">
              <v-col cols="auto">
                <v-sheet rounded color="grey-lighten-2" alignself="center">
                  <v-icon class="ma-3" size="x-large">mdi-cog-outline</v-icon>
                </v-sheet>
              </v-col>
              <v-col class="d-flex flex-column">
                <div class="d-flex flex-column h-100">
                  <h3>Deployment</h3>
                  <p class="mt-3 flex-grow-1">
                    Download configuration profile to set the license and
                    download the Patch24 app.
                  </p>
                  <div class="align-self-start">
                    <v-btn
                      @click="downloadLicenseConfig"
                      color="primary"
                      class="mt-3"
                      >Download Profile</v-btn
                    >
                    <v-btn
                      :disabled="downloadingAgent"
                      class="ml-6 mt-3"
                      @click="getAgentDownloadLink"
                      color="primary"
                      >Download App</v-btn
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card rounded="lg">
          <v-card-text class="d-flex flex-column">
            <h2 class="mb-1">License Keys</h2>
            <div class="mb-2">License API Key</div>
            <v-text-field
              v-model="apiKey"
              label=""
              readonly
              append-inner-icon="mdi-content-copy"
              @click:append-inner="copyToClipboard(apiKey)"
              variant="solo-filled"
            ></v-text-field>
            <div class="mt-0 mb-2">License Key</div>
            <v-textarea
              v-model="licenseKey"
              label=""
              readonly
              append-inner-icon="mdi-content-copy"
              @click:append-inner="copyToClipboard(licenseKey)"
              variant="solo-filled"
              rows="5"
            ></v-textarea>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Grant Support Access Dialog -->
    <v-dialog v-model="grantAccessDialog" max-width="500">
      <v-card>
        <v-card-text>
          <h1>Grant Support Access</h1>
          <p class="mb-4">
            Select the duration for which support access should be granted:
          </p>
          <v-radio-group v-model="selectedDuration" density="comfortable">
            <v-radio label="24 Hours" :value="24" />
            <v-radio label="48 Hours" :value="48" />
            <v-radio label="1 Week" :value="168" />
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="elevated" @click="grantAccessDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            variant="elevated"
            @click="grantSupportAccess"
            :loading="loading"
          >
            Grant Access
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Copied to clipboard overlay -->
    <v-snackbar
      v-model="showCopiedMessage"
      :timeout="2000"
      color="primary"
      location="bottom"
      size="small"
    >
      Copied to clipboard!
    </v-snackbar>
  </template>
</template>
